module.exports = __webpack_public_path__ + "static/media/BodyScan15.1ebb0753.m4a";